var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.707 8.707a1 1 0 000-1.414L11.343.929A1 1 0 109.93 2.343L15.586 8l-5.657 5.657a1 1 0 001.414 1.414l6.364-6.364zM1 7a1 1 0 000 2V7zm16 0H1v2h16V7z",
    fill: "#fff"
  })));
}
export default SvgArrowRight;